<template>
  <div class="d-flex flex-column h-100">
    <div class="d-flex justify-content-between">
      <div class="page-title-wrapper">
        <div class="page-title active">
          {{ $t('shop.catalog.archived') }}
        </div>
      </div>
      <div class="pt-3">
        <div
          v-tippy
          :content="$t('shop.catalog.catalogs')"
          class="light-button"
          @click="showCatalogs"
        >
          <i class="far fa-list" />
        </div>
      </div>
    </div>
    <Loader v-if="pending" />
    <div class="flex-grow-1 catalogs-scroll">
      <div
        v-for="({ date, list }) in grouppedCatalogs"
        :key="date"
      >
        <div class="group-title">
          {{ date }}
        </div>
        <div
          v-for="c in list"
          :key="c.id"
          class="d-flex align-items-center mb-2"
        >
          <CatalogRow
            :catalog="c"
            class="flex-grow-1"
            @edit="openCatalog(c.id)"
          />
          <Tippy
            v-if="payeeAdmin"
            :ref="`restore-popup-${c.id}`"
            trigger="click"
            theme="light"
            arrow
            interactive
          >
            <template #trigger>
              <button
                v-tippy
                :content="$t('general.restore')"
                class="btn btn-outline-primary icon-btn ml-2"
              >
                <i class="fa-solid fa-rotate-left" />
              </button>
            </template>

            <button
              class="btn btn-secondary btn-sm btn-block"
              :disabled="restorePending"
              @click="restore(c.id)"
            >
              <i class="fa-solid fa-arrow-turn-left pr-2" />
              {{ $t('general.restore') }}
            </button>
          </Tippy>
        </div>
      </div>
      <div
        v-if="!pending && archivedCatalogs.length === 0"
        class="text-center text-secondary pt-3"
      >
        {{ $t('shop.catalog.noArchived') }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import CatalogRow from './CatalogRow';

export default {
  data: () => ({
    pending: false,
    restorePending: false,
  }),
  components: {
    CatalogRow,
  },
  computed: {
    ...mapGetters(['payeeId', 'payeeAdmin']),
    ...mapGetters('shop', ['archivedCatalogs']),
    grouppedCatalogs() {
      return Object.values(this.archivedCatalogs
        .reduce((acc, curr) => {
          const date = moment(curr.archivedDate).format('DD MMMM YYYY');

          if (!acc[date]) {
            acc[date] = { date, list: [] };
          }

          acc[date].list.push(curr);
          return acc;
        }, {}));
    },
  },
  methods: {
    ...mapActions('shop', ['getArchivedShopCatalogs', 'restoreShopCatalog']),
    showCatalogs() {
      this.$router.push(`/payee/${this.payeeId}/shop/catalogs`);
    },
    openCatalog(id) {
      this.$router.push(`/payee/${this.payeeId}/shop/${id}/orders`);
    },
    restore(catalogId) {
      if (this.restorePending) {
        return;
      }

      // hide the confirmation before the row is removed from the list,
      // otherwise the popup outlives its unmounted trigger
      const popup = this.$refs[`restore-popup-${catalogId}`];
      if (popup && popup[0]) {
        popup[0].tippy().hide();
      }

      this.restorePending = true;
      this.restoreShopCatalog({
        params: {
          catalogId,
        },
      })
        .finally(() => {
          this.restorePending = false;
        });
    },
    request() {
      this.pending = true;
      this.getArchivedShopCatalogs()
        .finally(() => {
          this.pending = false;
        });
    },
  },
  created() {
    this.$emit('page', 'catalogs');
    this.request();
  },
};
</script>

<style lang="scss" scoped>
.catalogs-scroll {
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 16px;
}

.group-title {
  font-weight: 500;
  padding-top: 10px;
  padding-bottom: 5px;
}
</style>
